export default __webpack_public_path__ + "static/media/line.efe8106e.svg";